export default __webpack_public_path__ + "static/toolbar-selector-edit-dark-mode-9cbec4e2ed33b670742860c587266b23.mp4";